import { ResponsiveCropDimensions } from './ImageGallery.types';

export const CAROUSEL_CROP_DIMS: ResponsiveCropDimensions = {
    xs: { w: 540 },
    s: { w: 768 },
    m: { w: 1024 },
    l: { w: 1280 },
    xl: { w: 1348 },
};
